import { ACCOUNT_RESOURCE_NAME, ACCOUNT_RESOURCE_STATUS } from '@enums';
import { useStore } from '@hooks';
import { UNAVAILABLE_REASON } from '../constants';

// A campaign type is unavailable either because its data is still being synced,
// or because the sync is done and there is genuinely nothing to advertise.
const getUnavailableReason = (hasData, syncProgress, resourceNames) => {
    if (hasData) return null;

    const isSyncing = resourceNames.some((name) => {
        const resource = syncProgress.find((item) => item.name === name);
        return (
            resource &&
            (resource.status === ACCOUNT_RESOURCE_STATUS.PENDING ||
                resource.status === ACCOUNT_RESOURCE_STATUS.IN_PROGRESS)
        );
    });

    return isSyncing ? UNAVAILABLE_REASON.SYNCING : UNAVAILABLE_REASON.EMPTY;
};

const useTypeAvailability = () => {
    const store = useStore();
    const { bestSellersCount, productCollections, productTypes, syncProgress } = store.accountsStore.currentAccount;

    // Fail open: an API that does not return bestSellersCount (older than this build)
    // must not gray out the card for every merchant.
    const hasBestSellers = bestSellersCount === null || bestSellersCount > 0;

    return {
        bestSellers: getUnavailableReason(hasBestSellers, syncProgress, [ACCOUNT_RESOURCE_NAME.PRODUCT_STATS]),
        specificCollections: getUnavailableReason(productCollections.length > 0, syncProgress, [
            ACCOUNT_RESOURCE_NAME.CUSTOM_COLLECTIONS,
            ACCOUNT_RESOURCE_NAME.SMART_COLLECTIONS
        ]),
        specificProductTypes: getUnavailableReason(productTypes.length > 0, syncProgress, [
            ACCOUNT_RESOURCE_NAME.PRODUCTS
        ])
    };
};

export { useTypeAvailability };
